import { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export type CreateStore = <T = unknown>(
  namespace: string,
  creator: StateCreator<T, [], []>,
) => UseBoundStore<StoreApi<T>>;

export type GetStore = <T = unknown>(
  namespace: string,
) => UseBoundStore<StoreApi<T>>;
